'use strict';

/**
 * @ngdoc type
 * @name mx.SolutionBuilderAgent.SearchQueryCondition
 * @module mx.SolutionBuilderAgent
 *
 * @description
 * An object containing search query condition information (Query condition model)
 * Constructor accepts conditionOptions as param like:
 * ```javascript
 var conditionOptions = {
	Property: 'fieldName',
	Value: 'test',
	Operator: mx.sb.Agent.DataQuery.FilterOperatorsFactory.operators.Equals.value
 };

 var condition = new SearchQueryCondition(conditionOptions);
 * ```
 * @property {string} Property - Gets or sets condition property name. Default: ''
 * @property {string} Value - Gets or sets condition value. Default: ''
 * @property {int} Operator - Gets or sets condition operator.<br> Default: mx.sb.Agent.DataQuery.FilterOperatorsFactory.operators.Equals.value (1)
 * @property {string} OperatorTitle - Gets condition operator title. Title - is how operator displayed in pseudo-SQL query view
 * @property {string} OperatorLabel - Gets condition operator label. Label - is how operator displayed in query builder
 */
angular.module('mx.SolutionBuilderAgent').factory('mx.SolutionBuilderAgent.SearchQueryCondition', searchQueryConditionFactory);
searchQueryConditionFactory.$inject = ['mx.sb.Agent.DataQuery.FilterOperatorsFactory', 'mx.utils'];
export default function searchQueryConditionFactory(filterOperatorsFactory, utils) {
	class MxSearchQueryCondition {
		constructor(conditionOptions) {
			conditionOptions = conditionOptions || {};

			Object.defineProperty(this, 'id', {
				enumerable: true,
				writable: true,
				value: conditionOptions.Id || utils.guid(),
			});

			Object.defineProperty(this, 'property', {
				enumerable: true,
				writable: true,
				value: conditionOptions.Property || '',
			});

			Object.defineProperty(this, 'value', {
				writable: true,
				enumerable: true,
				value: conditionOptions.Value || [],
			});
			Object.defineProperty(this, 'type', {
				writable: true,
				enumerable: true,
				value: conditionOptions.Type || '',
			});

			Object.defineProperty(this, 'operator', {
				writable: true,
				enumerable: true,
				value: Number(conditionOptions.Operator || filterOperatorsFactory.operators.Equals.value),
			});

			Object.defineProperty(this, 'operatorTitle', {
				get: function () {
					return filterOperatorsFactory.getOperatorByValue(this.operator).name;
				},
			});

			Object.defineProperty(this, 'operatorLabel', {
				get: function () {
					return filterOperatorsFactory.getOperatorByValue(this.operator).label;
				},
			});

			Object.defineProperty(this, 'operatorTechnicalName', {
				get: function () {
					return filterOperatorsFactory.getOperatorByValue(this.operator).technicalName;
				},
			});

			Object.defineProperty(this, '__valid', {
				value: false,
				enumerable: true,
				writable: true,
			});
			Object.defineProperty(this, '__property', {
				value: null,
				enumerable: true,
				writable: true,
			});
			Object.defineProperty(this, '__enumeration', {
				value: null,
				enumerable: true,
				writable: true,
			});
			Object.defineProperty(this, '__expanded', {
				value: true,
				enumerable: true,
				writable: true,
			});
		}

		/**
		 * @ngdoc method
		 * @name SearchQueryCondition#toSqlView
		 *
		 * @description
		 * Extracts pseudo-SQL expression of condition
		 *
		 * @return {string} Condition pseudo-SQL presentation
		 */
		toSqlView() {
			return this.type === 'Expression' ? this.value : '[' + this.property + '] ' + this.operatorTitle + ' "' + this.value;
		}

		/**
		 * @ngdoc method
		 * @name SearchQueryCondition#toJSON
		 *
		 * @description
		 * Returns JSON serialised search query condition prepared for server side
		 *
		 * @return {object} returns an object that represents search query condition
		 */
		toJSON() {
			var result = {
				Property: this.property,
				Operator: this.operator,
				Value: Array.isArray(this.value) ? this.value : [this.value],
			};

			if (this.type === 'Expression') {
				result.IsExpression = true;
				result.Type = 'Expression';
				result.Title = 'Expression';
			}

			return result;
		}
	}

	return MxSearchQueryCondition;
}
